import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/api';

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 35000
});

apiClient.interceptors.request.use(
  (config) => {
    let token;
    const user = localStorage.getItem('user');
    if (user) {
      try {
        const parsedUser = JSON.parse(user);
        token = parsedUser?.token || '';
      } catch (error) {
        console.error('Error parsing user token:', error);
      }
    }

    if (token && config.headers) {
      config.headers['AuthorizationToken'] = `${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  response => response,
  (error) => Promise.reject(error)
);

class ModerationService {
  /**
   * Get pending moderation videos
   */
  async getPendingModeration(limit = 20, skip = 0) {
    try {
      const response = await apiClient.get('/moderation/pending', {
        params: { limit, skip }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching pending moderation:', error);
      throw error;
    }
  }

  /**
   * Get moderation result by fileName
   */
  async getModerationByFileName(fileName) {
    try {
      const response = await apiClient.get(`/moderation/file/${fileName}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching moderation by filename:', error);
      throw error;
    }
  }

  /**
   * Approve a video
   */
  async approveVideo(moderationId, notes = '') {
    try {
      const response = await apiClient.post(`/moderation/${moderationId}/approve`, {
        notes
      });
      return response.data;
    } catch (error) {
      console.error('Error approving video:', error);
      throw error;
    }
  }

  /**
   * Reject a video
   */
  async rejectVideo(moderationId, notes = '') {
    try {
      const response = await apiClient.post(`/moderation/${moderationId}/reject`, {
        notes
      });
      return response.data;
    } catch (error) {
      console.error('Error rejecting video:', error);
      throw error;
    }
  }
}

export default new ModerationService();
